<template>
  <div class="col-md align-items-start mt-3 mt-md-0 mx-0 px-0">
    <ul class="kpis-eq col-md ml-0 ml-md-3 px-0">
      <li class="flex-grow-1">
        <div>
          M2 construidos
          <span class="float-right text-nowrap">
            = {{ formatoNumerico(info.metrosContruidos) }} m
            <sup>2</sup>
          </span>
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          M2 construidos laboratorio
          <span class="float-right text-nowrap">
            = {{ formatoNumerico(info.metrosContruidosLaboratorio) }} m
            <sup>2</sup>
          </span>
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          M2 construidos áreas verdes
          <span class="float-right text-nowrap">
            = {{ formatoNumerico(info.metrosContruidosAreasVerdes) }} m
            <sup>2</sup>
          </span>
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          m2 construidos biblioteca
          <span class="float-right text-nowrap">
            = {{ formatoNumerico(info.metrosContruidosBiblioteca) }} m
            <sup>2</sup>
          </span>
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          Nº laboratorios
          <span class="float-right text-nowrap"
            >= {{ formatoNumerico(info.numeroLaboratorios) }}</span
          >
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          Nº de computadores
          <span class="float-right text-nowrap"
            >= {{ formatoNumerico(info.numeroComputadores) }}</span
          >
        </div>
      </li>
      <li class="flex-grow-1">
        <div>
          Nº de volúmenes de biblioteca
          <span class="float-right text-nowrap"
            >= {{ formatoNumerico(info.numeroVolumenesBiblioteca) }}</span
          >
        </div>
      </li>
    </ul>
    <div
      class="col col-md-12 d-block pt-2 mr-auto"
      style="text-align: justify; text-justify: inter-word;"
    >
      <p class="mb-0">
        <small
          >Información obtenida a través de SIES, correspondiente a la informada
          por las instituciones en el proceso 2023 referida a los inmuebles y
          recursos disponibles al 30 de diciembre de 2022.</small
        >
      </p>
    </div>
  </div>
</template>

<script>
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "Infraestructura",
  props: {
    info: { type: Object }
  },
  methods: {
    formatoNumerico(valor) {
      return FormatoMonetario.getFormatoNumerico(valor);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/fichaInstitucion/Infraestructura.vue